module.exports = __webpack_public_path__ + "static/img/reyna.057de91e.png";